<div class="tw-relative tw-flex tw-h-dvh tw-w-full tw-flex-col tw-overflow-y-auto tw-bg-white tw-font-body">

  <!-- Hero -->
  <div class="tw-relative tw-h-66 tw-shrink-0">
    <img [src]="heroImage" class="tw-h-full tw-w-full tw-object-cover tw-object-top" alt="" />
    <button type="button" (click)="back()" aria-label="Back"
      i18n-aria-label="@@back"
      class="tw-fixed tw-left-4 tw-top-4 tw-z-20 tw-flex tw-h-10 tw-w-10 tw-min-w-unset tw-items-center tw-justify-center tw-rounded-3 tw-border-none tw-bg-gray-800 tw-p-0 tw-shadow-z13">
      <cs-icon class="tw-h-6 tw-w-6 tw-text-white" [iconName]="'arrow_back'"></cs-icon>
    </button>
  </div>

  <!-- Content card -->
  <div class="tw-relative tw-z-10 tw--mt-6 tw-flex tw-flex-1 tw-flex-col tw-rounded-t-5 tw-bg-white tw-px-6 tw-pt-6">

    <!-- Top content -->
    <div class="tw-flex tw-flex-1 tw-flex-col tw-gap-6 tw-pb-4">

      <!-- Title + concern chips -->
      <div class="tw-flex tw-flex-col tw-gap-2">
        <h1 class="tw-m-0 tw-font-lexend tw-text-700 tw-font-bold tw-text-gray-800"
          i18n="@@trustInfoTitle">{{ userName() }}, you are at the right place!</h1>
        @if (chips().length) {
          <div class="tw-flex tw-items-center tw-gap-1 tw-flex-wrap">
            @for (chip of chips(); track chip.label) {
              <span
                class="tw-flex tw-h-6 tw-text-nowrap tw-items-center tw-justify-center tw-rounded-1 tw-border tw-border-solid tw-border-teal-200 tw-px-3 tw-font-body tw-text-black"
                [ngClass]="[chip.highlighted ? 'tw-bg-teal-100' : 'tw-bg-white/50', isDevnagriScript() ? 'tw-text-200' : 'tw-text-100']">{{ chip.label }}</span>
            }
          </div>
        }
      </div>

      <!-- Description -->
      <p class="tw-m-0 tw-font-body tw-text-300 tw-leading-5.5 tw-text-gray-500">{{ description() }}</p>

      <!-- Stat cards -->
      <div class="tw-flex tw-items-stretch tw-gap-3">
        <div class="tw-flex tw-flex-1 tw-flex-col tw-gap-4 tw-justify-between tw-overflow-hidden tw-rounded-2.5 tw-bg-teal-25 tw-px-3 tw-py-2.5">
          <img [src]="leftIcon" class="tw-h-8 tw-w-8 tw-object-contain tw-mix-blend-multiply" alt="" />
          <div class="tw-flex tw-flex-col">
            <span class="tw-font-lexend tw-text-650 tw-font-bold tw-text-gray-800">{{ leftStat().value }}</span>
            <span class="tw-font-lexend tw-text-300 tw-text-gray-800">{{ leftStat().label }}</span>
          </div>
        </div>
        <div class="tw-flex tw-flex-1 tw-flex-col tw-gap-4 tw-justify-between tw-overflow-hidden tw-rounded-2.5 tw-bg-teal-25 tw-px-3 tw-py-2.5">
          <img [src]="rightIcon" class="tw-h-8 tw-w-8 tw-object-contain tw-mix-blend-multiply" alt="" />
          <div class="tw-flex tw-flex-col">
            <span class="tw-font-lexend tw-text-650 tw-font-bold tw-text-gray-800">{{ rightStat().value }}</span>
            <span class="tw-font-lexend tw-text-300 tw-text-gray-800">{{ rightStat().label }}</span>
          </div>
        </div>
      </div>

    </div>

    <!-- Footnote + CTA (sticky to viewport bottom while the whole page scrolls) -->
    <div class="tw-sticky tw-bottom-0 tw-flex tw-flex-col tw-items-center tw-bg-white tw-pt-3 tw-pb-safe-area-footer">
      <p class="tw-mb-2 tw-text-center tw-font-body tw-text-100 tw-leading-4 tw-text-teal-450"
        i18n="@@trustInfoFootnote">Just a few quick questions &amp; hair photo - takes 5 minutes</p>
      <button csButton (click)="proceed()"
        class="shine-button tw-relative tw-w-full tw-overflow-hidden"
        i18n="@@takeHairTest">Take Hair Test</button>
    </div>

  </div>
</div>
